// extracted by mini-css-extract-plugin
module.exports = {"header":"CannedDeliveryInstructions__header___FZJBX colors__primary___6imLg"};